import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import ReviewBody from "./ReviewBody";
import { useDispatch, useSelector } from "react-redux";
import { EMenuActions } from "../../store";

export const Review = () => {
	let dispatch = useDispatch();
	//close the review page
	const handleCloseReview = () => {
		dispatch(EMenuActions.setReview(false));
	};
	//stops close review page from affecting children of the div
	const handleNoPropagate = (e) => {
		e.stopPropagation();
	};

	return (
		<div onClick={handleCloseReview} className="fixed w-full h-[100vh] top-0 py-12 lg:py-12 lg:px-24 z-10 overflow-hidden bg-dark/70">
			<div onClick={handleNoPropagate}>
				<div className="w-[90%] m-auto py-3 mt-5 rounded-t-sm items-center bg-secondary flex justify-between px-4">
					<h1 className="text-white font-bold flex justify-center">Customer Feedback</h1>
					<div onClick={handleCloseReview} className="cursor-pointer">
						<FontAwesomeIcon icon={faTimes} size="2xl" className="text-black" />
					</div>
				</div>
				{/* body of the review questions */}
				<ReviewBody />
			</div>
		</div>
	);
};
